(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name managePairing.controller:GeneratePairingCtrlCtrl
   *
   * @description
   *
   */
  angular
    .module('managePairing')
    .controller('GeneratePairingCtrlCtrl', GeneratePairingCtrlCtrl);

  function GeneratePairingCtrlCtrl($uibModalInstance, modalParams, applicationConstants, CommonLogicService) {
      var vm = this;
      vm.ctrlName = 'GeneratePairingCtrlCtrl';
      vm.model = {
          pairingModel: modalParams.pairingModel,
          displayWeekdays: CommonLogicService.getDayOfWeeks(),
          minConnTime: 40
      };

      vm.closeMe = function () {
          $uibModalInstance.close();
      };

      vm.sendGeneratePairing = function(){
          vm.frmGeneratePairing.$setSubmitted();
          //vm.frmGeneratePairing.$setValidity()

          if(vm.frmGeneratePairing.$valid){
              var pairingModel = vm.model.pairingModel;
              pairingModel.fromDate = vm.model.fromDate;
              pairingModel.toDate = vm.model.toDate;
              pairingModel.displayWeekdays = vm.model.displayWeekdays;
              pairingModel.minConnTime = vm.model.minConnTime;
              var param = {
                  save: true,
                  pairingModel: pairingModel
              };
              $uibModalInstance.close(param);
          }
      };

      vm.changeDateTime = function(flg){
          if (vm.model.toDate && vm.model.fromDate){
              if ('fromDate' == flg){
                  vm.model.toDate = vm.model.fromDate;
              }
              var fD = moment(vm.model.fromDate, applicationConstants.SETTINGS.DATE_FORMAT);
              var eD = moment(vm.model.toDate, applicationConstants.SETTINGS.DATE_FORMAT);
              if (eD.diff(fD)<0 && vm.model.toDate.length>4){
                  if ( 'toDate' == flg ){
                      vm.model.fromDate = moment(vm.model.toDate, applicationConstants.SETTINGS.DATE_FORMAT).format(applicationConstants.SETTINGS.DATE_FORMAT);
                  }
              }
              CommonLogicService.applyDaySelection(vm.model.displayWeekdays, vm.model.fromDate, vm.model.toDate);
          }
      };

      vm.setSingleDay = function(day){
          if (day.value==='all'){
              angular.forEach(vm.model.displayWeekdays, function(date,i){
                  if (date.editable){
                      date.selected = day.selected;
                  }
              });
          }
      };

  }
}());
